import {Component, Input} from '@angular/core';
import {PasswordPolicy} from '../../../../models/password-policy.model';

@Component({
    selector: 'app-password-policy-info',
    templateUrl: './password-policy-info.component.html'
})
export class PasswordPolicyInfoComponent {
    @Input() passwordPolicy: PasswordPolicy;
}
